import type { GetPermissionListResultDto, PermissionGrantInfoDto } from "@/entities/admin/types"

/** false — скрыть депонирование из UI; код и маршруты остаются. */
export const isDepositsUiEnabled = true

/** Имена политик модуля депонирования и аудита депозитов (ABP). */
export const isDepositRelatedPermissionName = (name: string | null | undefined): boolean => {
  if (!name) return false
  return /\.Deposits(\.|$)/.test(name)
}

const filterPermissionList = (permissions: PermissionGrantInfoDto[]): PermissionGrantInfoDto[] => {
  if (isDepositsUiEnabled) return permissions
  return permissions.filter((p) => !isDepositRelatedPermissionName(p.name))
}

/** Группы и права для отображения в дереве ролей (без депонирования при выключенном UI). */
export const filterPermissionGroupsForDisplay = (
  data: GetPermissionListResultDto | null,
): GetPermissionListResultDto | null => {
  if (!data || isDepositsUiEnabled) return data
  const groups = (data.groups ?? [])
    .map((group) => ({
      ...group,
      permissions: filterPermissionList(group.permissions ?? []),
    }))
    .filter((group) => (group.permissions?.length ?? 0) > 0)
  return { ...data, groups }
}
